<template>
  <div class="wrap type-main">
    <!-- inner -->
    <div class="inner">
      <div class="main-flex">
        <div class="main-card1">
          <img class="setImg" src="@/../public/img/mainImg3.jpg">
        </div>
        <div class="main-card2" style="margin-bottom: 59px;">
          <div class="white-box card creditcard main-board">
            <div class="top-area">
              <h1 class="box-title">판매지원</h1>
              <router-link class="btn-more" to="/listSaleSupportGuide"></router-link>
            </div>
            <div class="data-box">
              <Tab :tab="tab" :active-btn="activeBtn" @changeTab="changeTab"/>
              <table class="table" style="margin-top:20px;">
                <colgroup>
                  <col width="60%;">
                  <col width="15%;">
                  <col width="20%;">
                </colgroup>
                <tbody>
                  <tr v-for="(item,i) in supportList" :key="i" @click="goMenu11(item)" class="file-download"> 
                    <td>{{ item.bsubject }}</td>
                    <td style="text-align:center; color:#DEB887;">{{ item.createdByNm }}</td>
                    <td style="color:#A9A9A9;">{{ item.creationDate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="white-box card creditcard main-board">
            <div class="top-area">
              <h1 class="box-title">소식지</h1>
              <router-link class="btn-more" to="/ListNewsletter"></router-link>
            </div>
            <div class="data-box">
              <table class="table" style="margin-top:20px;">
                <colgroup>
                  <col width="60%;">
                  <col width="15%;">
                  <col width="20%;">
                </colgroup>
                <tbody>
                  <tr v-for="(item,i) in mainList21" :key="i" @click="goMenu21(item)" class="file-download"> 
                    <td>{{ item.bsubject }}</td>
                    <td style="text-align:center; color:#DEB887;">{{ item.createdBy }}</td>
                    <td style="color:#A9A9A9;">{{ item.creationDate }}</td>
                  </tr>
                </tbody>
              </table>
                            
            </div>
          </div>
        </div>
      </div>
             
    </div>
    <!-- //inner -->
       
    <!-- footer -->
    <div class="footer2">
      <span class="copyright">Copyright 2018 LUCOMS Co., Ltd. All Rights Reserved.</span>
    </div>
    <!-- //footer -->
        
    <Notic v-if="this.$cookie.get(popList.id) != 'done' && popList !=''" :pop-list="popList"/> <!-- 소식지 팝업 1개 -->
    <Notic1 v-if="this.$cookie.get(popList1.id) != 'done' && popList1 !=''" :pop-list="popList1"/>
    <Notic2 v-if="this.$cookie.get(popList2.id) != 'done' && popList2 != ''" :pop-list="popList2"/>
    <Notic3 v-if="this.$cookie.get(popList3.id) != 'done' && popList3 != ''" :pop-list="popList3"/>
    <!-- 소식지 팝업 여러개 
        <div v-for="(item,i) in pops" :key="i">
            <Notic :popList="item" :no="i.toString()"/>
        </div>
        -->
  </div>
  <!-- //wrap -->
</template>

<script>
import _ from 'lodash';
import Tab from '@/components/Tab.vue';
import Notic from '@/components/Notice/Notic.vue';
import Notic1 from '@/components/Notice/Notic1.vue';
import Notic2 from '@/components/Notice/Notic2.vue';
import Notic3 from '@/components/Notice/Notic3.vue';

export default {
  name: 'MyMain',
  components: {
      Tab, Notic, Notic1, Notic2, Notic3
  },
  data() {
    return {
        tab:[
            {tabName:'전체', tabCss:"btn btn-primary", tabNo:'0'},
            {tabName:'정책안내', tabCss:"btn btn-outline-primary", tabNo:'1'},
            {tabName:'신제품안내', tabCss:"btn btn-outline-primary", tabNo:'2'},
            {tabName:'교육자료', tabCss:"btn btn-outline-primary", tabNo:'3'},
        ],
        activeBtn:true,
        mainList11:[],
        supportList: [],
        mainList21:[],
        letterList: [],
        boardSubCd: '',
        // pops:[], //소식지 팝업 여러개
        popList:'', //소식지 팝업 한개
        popList1:'',
        popList2:'',
        popList3:'',
        today:this.$moment().format('YYYYMMDD')
    }
  },
  mounted() {
    /**
     * * 메인화면을 사용 docList 으로 무족건 이동.
     */
     const {groupUId} = this.$store.state.loginInfo;
    if(groupUId && groupUId > -1) {
      if(groupUId === 29) {
        this.$router.push({path: `/AgencyReg`});
      } else {
        this.$router.push({path: `/DocList`});
      }
    } else {
      this.$router.push({path: `/login`});
    }

    //아래 호출 부분은 오텍에서 사용하던거..
    /**
     * * TODO : 해당 메인 화면에서 불필요한메서드는 싹 제거하는 정리가 필요함.
     */
      // this.getMainList11();
      // this.getMainList21();
      // this.getPopList()
  },
  methods: {
    fromToAscii(code) {
      return code > 0 ? `11${String.fromCharCode(64+(parseInt(code)))}` : "";
    },
    /** 탭 페이지 이동(조건에 따라 api 호출 해도 되고 component를 활성화 해도 된다.) */
    changeTab(no){
      this.supportList = this.mainList11[no].data;
    },
    async getMainList11(){
      let [ALL, A, B, C] = await Promise.all([
        this.$board.get(`mainBoardList`,{
          params:{
              boardCd:'11',
              boardSubCd: `${this.fromToAscii(0)}`,
          }
        }),
        this.$board.get(`mainBoardList`,{
          params:{
              boardCd:'11',
              boardSubCd: `${this.fromToAscii(1)}`,
          }
        }),
        this.$board.get(`mainBoardList`,{
          params:{
              boardCd:'11',
              boardSubCd: `${this.fromToAscii(2)}`,
          }
        }),
        this.$board.get(`mainBoardList`,{
          params:{
              boardCd:'11',
              boardSubCd: `${this.fromToAscii(3)}`,
          }
        }),
      ]);
      
      this.mainList11 = [ALL, A, B, C];
      this.supportList = this.mainList11[0].data;
    },
    async getMainList21(){
      let [res] = await Promise.all([
        this.$board.get(`mainBoardList`,{
          params:{
              boardCd:'21',
              boardSubCd:'',
          }
        })
      ]);
      this.mainList21 = res.data;
    },
    goMenu11(item){
        this.$router.push({          
            name: 'boardRead',
            params: {
                title : '판매지원',
                boardCd: '11',
                boardId : item.id 
            }
        })  
    },
    goMenu21(item){
        this.$router.push({          
            name: 'boardRead',
            params: {
                title : '소식지',
                boardCd: '21',
                boardId : item.id 
            }
        })  
    },
    getPopList(){
      this.$board.get(`boardPop`,{
            params:{
                today:this.today,
            }
        }).then(response => {
          switch(response.data.length){
              case 1:
                  this.popList=response.data[0];
                  this.popList.id=this.popList.id.toString()
                  break;
              case 2:
                  this.popList=response.data[0];
                  this.popList1=response.data[1];
                  this.popList.id=this.popList.id.toString();
                  this.popList1.id=this.popList1.id.toString()
                  break;
              case 3:
                  this.popList=response.data[0];
                  this.popList1=response.data[1];
                  this.popList2=response.data[2];
                  this.popList.id=this.popList.id.toString();
                  this.popList1.id=this.popList1.id.toString()
                  this.popList2.id=this.popList2.id.toString()
                  break;
              case 4:
                  this.popList=response.data[0];
                  this.popList1=response.data[1];
                  this.popList2=response.data[2];
                  this.popList3=response.data[3];
                  this.popList.id=this.popList.id.toString();
                  this.popList1.id=this.popList1.id.toString()
                  this.popList2.id=this.popList2.id.toString()
                  this.popList3.id=this.popList3.id.toString()
                  break;
              default:
                  this.popList=''
          }

            //this.popList=response.data[0]; //소식지 팝업 1개
            /** 소식지 팝업 여러개 
            this.popList=response.data;
            const pop = this.$store.state.popList
            for(let i=0; i<pop.length; i++){
                for(let j=0; j<this.popList.length; j++){
                    if(pop[i].id == this.popList[j].id && pop[i].date == this.today){
                        this.popList.splice(j,1)
                    }
                }
            }
            */
        })

      }
    },
    
};

</script>


<style scoped lang="scss">

@import "public/css/main";

</style>
